import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="relative bg-gradient-to-b from-cream to-white pt-24 md:pt-32 pb-12 md:pb-16 px-4" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-8 md:mb-12" data-id="element-75">
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-warm-brown mb-4 md:mb-6 leading-tight px-2" data-id="element-76">
            Si tienes más de 50 años y todavía crees que tus suplementos de
            cúrcuma o jengibre te están ayudando…
          </h1>
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl text-terracotta mb-6 md:mb-8 px-2" data-id="element-77">
            Necesitas leer esto antes de gastar un centavo más.
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-700 font-medium mb-6 md:mb-8 px-2" data-id="element-78">
            El 90% de lo que tomas termina en el inodoro. Aquí está la razón — y
            la solución que los herbalistas ancestrales conocían desde hace
            siglos.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="mb-6 md:mb-8 flex justify-center px-4" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/iGnq7aZZfUXy4Uq6Xsj1i2/Imagen_Sinergia_Ancestral.png" alt="Sinergia Ancestral - Ebook en tablet con ingredientes naturales" className="max-w-full h-auto rounded-lg shadow-2xl" style={{
            maxHeight: '400px'
          }} data-id="element-80" />
          </motion.div>

          <motion.button initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} onClick={scrollToPricing} className="bg-terracotta hover:bg-terracotta-dark text-white font-bold text-lg sm:text-xl md:text-2xl py-4 md:py-5 px-8 md:px-10 rounded-lg shadow-xl transition-all duration-200 inline-block cursor-pointer" aria-label="Ver precio de Sinergia Ancestral" data-id="element-81">
            🌿 QUIERO MI GUÍA
          </motion.button>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="bg-white rounded-lg shadow-xl p-6 md:p-12 border-2 border-sage-light" data-id="element-82">
          <div className="prose prose-base md:prose-lg max-w-none" data-id="element-83">
            <p className="text-gray-700 mb-3 md:mb-4" data-id="element-84">
              Eran las 6:47 de la mañana.
            </p>
            <p className="text-gray-700 mb-3 md:mb-4" data-id="element-85">
              Me levanté de la cama como lo hacía cada día — lentamente, con
              cuidado, esperando que mis rodillas "arrancaran" antes de poner
              todo mi peso sobre ellas.
            </p>
            <p className="text-gray-700 mb-3 md:mb-4" data-id="element-86">Fui a la cocina.</p>
            <p className="text-gray-700 mb-3 md:mb-4" data-id="element-87">
              Abrí el cajón de los suplementos.
            </p>
            <p className="text-gray-700 mb-3 md:mb-4" data-id="element-88">
              Cúrcuma. Colágeno. Omega 3. Magnesio. Vitamina D.
            </p>
            <p className="text-gray-900 font-bold text-lg md:text-xl mb-3 md:mb-4" data-id="element-89">
              Siete cápsulas. Cada mañana. Durante tres años.
            </p>
            <p className="text-gray-700 mb-3 md:mb-4" data-id="element-90">
              Y sin embargo, ahí estaba — con 57 años, rígida, cansada, con una
              digestión que parecía haber firmado su dimisión sin avisarme.
            </p>
            <p className="text-gray-700 mb-3 md:mb-4" data-id="element-91">
              El médico decía que era normal. <em data-id="element-92">"Es la edad."</em>
            </p>
            <p className="text-gray-700 mb-3 md:mb-4" data-id="element-93">
              La farmacéutica vendía más suplementos.{' '}
              <em data-id="element-94">"Prueba con este nuevo."</em>
            </p>
            <p className="text-gray-700 mb-4 md:mb-6" data-id="element-95">
              Y yo seguía tomando pastillas con una mano mientras con la otra
              buscaba en Google <em data-id="element-96">"por qué no me funciona la cúrcuma"</em> a
              las 7 de la mañana en pijama.
            </p>
            <p className="text-gray-900 font-bold text-lg md:text-xl mb-3 md:mb-4" data-id="element-97">
              Hasta que encontré algo que lo cambió todo.
            </p>
            <p className="text-gray-700 mb-2" data-id="element-98">No fue un médico nuevo.</p>
            <p className="text-gray-700 mb-2" data-id="element-99">No fue un suplemento más caro.</p>
            <p className="text-gray-700 mb-2" data-id="element-100">No fue una dieta de moda.</p>
            <p className="text-gray-900 font-semibold text-base md:text-lg mt-4 md:mt-6" data-id="element-101">
              Fue un principio tan antiguo como la humanidad misma — que la
              industria de los suplementos lleva décadas ocultando porque si lo
              supieras, nunca más les comprarías una sola cápsula.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1
      }} className="flex justify-center mt-8 md:mt-12" data-id="element-102">
          <ChevronDownIcon className="w-8 h-8 text-sage animate-bounce" aria-hidden="true" data-id="element-103" />
        </motion.div>
      </div>
    </section>;
}